import type { Organization, IOrganizationRepository } from '@knownow/domain'
import { ForbiddenError } from '@knownow/domain'

export class GetOrganizationBySlugUseCase {
  constructor(private readonly orgRepo: IOrganizationRepository) {}

  async execute(slug: string, userId: string): Promise<Organization> {
    const org = await this.orgRepo.getBySlug(slug)
    const members = await this.orgRepo.getMembers(org.id)
    const isMember = members.some((m) => m.userId === userId)

    if (!isMember) {
      throw new ForbiddenError('You are not a member of this organization')
    }

    return org
  }
}
